export function convertToPercent(number: number, nbrOfDecimals: number): number {
  const decimalFactor = Math.pow(10, nbrOfDecimals)
  return Math.round(number * 100 * decimalFactor) / decimalFactor
}
// Rounds number and uses german number representation (comma as decimal separator and period for thousands)
/**
 * Takes number and converts to string with wanted number of decimals
 * @param {number | undefined} value number
 * @param {number} nbrOfDecimals wanted number of decimals
 * @returns string in locale format sv-SE
 */
export function formatNumber(value: number | undefined | null, nbrOfDecimals: number): string {
  if (value === undefined || value === null) return '-'
  // to swedish locale string
  return value.toLocaleString('sv-SE', {
    minimumFractionDigits: nbrOfDecimals,
    maximumFractionDigits: nbrOfDecimals
  })
}
// Sum all numbers in array used as the first parameter in reduce method, second parameter must be number 0
// example: array.reduce(sumNumbersInArray, 0)
export function sumNumbersInArray(total: number, num: number): number {
  return total + num
}
//
export function formatCoordinate(value: number): string {
  return value.toLocaleString('en-GB', {
    minimumFractionDigits: 9,
    maximumFractionDigits: 9
  })
}
